(ns ycweb.app.admin.wholesale.clientorders.clientorder.overview
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.tabs :as tabs]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.core :as yuc]
   [ycweb.util.comms :as comms]
   [util.transform :as trf]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.config.order :as o.cfg]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.creditnote :as credit-note-tab]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.invoice :as invoice-tab]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.attachment :as attachments]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.changelog :as changelog-tab]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.order :as order-tab]
   [ycweb.app.admin.wholesale.clientorders.clientorder.tabs.shipping :as shipping-tab]))

(defn confirm-leave? [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        unsaved-changes (cmn/curact process-atom :unsaved-changes)]
    (not (empty? unsaved-changes))))

(defmethod grid/action :admin.wholesale/client-order.discard [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        process-name (cmn/process-name app-atom)
        unsaved-changes (cmn/curact process-atom :unsaved-changes)
        field-keys (keys unsaved-changes)]
    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (update :client-order
            #(reduce
              (fn [acc field-key]
                (let [unsaved-change (get unsaved-changes field-key)]
                  (assoc acc field-key (:old-value unsaved-change))))
              % field-keys))
          (assoc :unsaved-changes {}))))))

(defmethod grid/action :admin.wholesale/client-order.save [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        customer-client-order-user-id (:client-order/user-id client-order)
        customers (cmn/curact process-atom :customers)
        customers-idx (yuc/index-by :client-order-user-id customers)
        customer (get customers-idx customer-client-order-user-id)]

    (cond
      (= dear-sync :pull)
      (grid/open-modal app-atom :grid/message
        {:title "Warning"
         :text
         (feedback/feedback :warning
           [:b "The system is set to sync from DEAR"]
           [:div
            [:p "The system is set to pull information from DEAR, saving has been disabled."]])})

      :else
      (let [form-fields (cmn/curact process-atom [:form :client-order])
            form-field-keys (keys form-fields)
            fields-with-errors (filter #(yuc/presence (get-in form-fields [% :error])) form-field-keys)]
        (toaster/open-overlay app-atom :admin.wholesale/client-order.overview)
        (when (not (empty? fields-with-errors))
          (swap! process-atom update-in [:form :client-order]
            (fn [form-fields]
              (reduce
                (fn [acc field-key]
                  (update acc field-key dissoc :error))
                form-fields fields-with-errors))))
        (comms/send :admin.wholesale/client-order.edit
          {:data [(assoc client-order :client-order/customer-id (:id customer))]})))))

(defmethod comms/receive :admin.wholesale/client-order.edit [app-atom {:keys [rows field-errors]}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
  (let [process-atom (cmn/process-cursor app-atom)
        process-name (cmn/process-name app-atom)
        client-order (cmn/curact process-atom :client-order)]

    (cond
      field-errors
      (swap! process-atom update-in [:form :client-order]
        #(merge % (w.cmn/overview-field-errors field-errors)))

      :else
      (let [rows-idx (yuc/index-by :client-order/id rows)
            row (get rows-idx (:client-order/id client-order))]

        (swap! app-atom update process-name
          (fn [process]
            (->
              process
              (assoc :unsaved-changes {})
              (update :client-order #(merge % row))
              (update-in [:form]
                (fn [form-entity]
                  (let [field-keys (keys row)]
                    (reduce
                      (fn [acc field-key]
                        (let [new-value (get row field-key)]
                          (cond
                            (get-in acc [:client-order field-key])
                            (update-in acc [:client-order field-key] assoc :value new-value)

                            :else
                            acc)))
                      form-entity field-keys)))))))

        (comms/send :admin.wholesale/client-order.order.item-list
          {:client-order/uuid (:client-order/uuid client-order)})

        (toaster/open-toast app-atom :success "Client order updated." {})))))

(defmethod grid/action :admin.wholesale/client-order.change-customer-details [app-atom {:keys [customer-id client-order-user-id]} _]
  (toaster/open-overlay app-atom :admin.wholesale/client-order.change-customer-details "Fetching customer preferences")
  (let [process-atom (cmn/process-cursor app-atom)
        process-name (cmn/process-name app-atom)
        form-value (cmn/curact process-atom [:form :client-order :client-order/user-id :value])]

    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (update :client-order
            #(assoc %
              :client-order/customer-id customer-id
              :client-order/user-id client-order-user-id))
          (update :unsaved-changes
            (fn [unsaved-changes]
              (cond
                (not= (yuc/presence form-value) (yuc/presence client-order-user-id))
                (assoc unsaved-changes
                  :client-order/user-id
                  {:old-value form-value :new-value client-order-user-id})

                :else
                (dissoc unsaved-changes :client-order/user-id)))))))
    (comms/send :admin.wholesale/client-order.change-customer-details {:customer-id customer-id})))

(defmethod comms/receive :admin.wholesale/client-order.change-customer-details
  [app-atom {:keys [customer-addresses customer-contacts]}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.change-customer-details)
  (let [process-atom (cmn/process-cursor app-atom)
        process-name (cmn/process-name app-atom)
        client-order (cmn/curact process-atom :client-order)
        customers (cmn/curact process-atom :customers)
        customers-idx (yuc/index-by :id customers)
        customer-id (cmn/curact process-atom [:client-order :client-order/customer-id])
        {:keys [tax-rule-id payment-term-id delivery-company-id display-name]}
        (get customers-idx (trf/tonumber customer-id))
        payment-terms-idx (yuc/index-by :id (cmn/curact process-atom :payment-terms))
        payment-term-description (:description (get payment-terms-idx payment-term-id))
        tax-rules-idx (yuc/index-by :id (cmn/curact process-atom :tax-rules))
        tax-rule-description (:description (get tax-rules-idx tax-rule-id))
        delivery-companies-idx (yuc/index-by :id (cmn/curact process-atom :delivery-companies))
        delivery-company (get delivery-companies-idx delivery-company-id)

        {:keys [tel email id]}
        (->>
          customer-contacts
          (filter :default-contact)
          (first))

        default-customer-addresses
        (filter :default-address customer-addresses)

        shipping-address
        (->>
          default-customer-addresses
          (filter #(contains? #{"Business" "Shipping"} (:address-type %)))
          (first))

        billing-address
        (->>
          default-customer-addresses
          (filter #(contains? #{"Business" "Billing"} (:address-type %)))
          (first))]

    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (assoc
            :customer-addresses customer-addresses
            :customer-contacts customer-contacts
            :list-all-customers display-name)
          (update :client-order
            #(assoc %
               :client-order/customer-contact-id id
               :client-order/tax-rule-id tax-rule-id
               :client-order/tax-rule-description tax-rule-description
               :client-order/payment-term-id payment-term-id
               :client-order/payment-term-description payment-term-description
               :client-order/customer-shipping-address-id (:id shipping-address)
               :client-order/customer-billing-address-id (:id billing-address)
               :client-order/shipping-display-line-2 (:display-line-2 shipping-address)
               :client-order/billing-display-line-2 (:display-line-2 billing-address)
               :client-order/delivery-company-id (:id delivery-company)
               :client-order/email email
               :client-order/tel tel))
          (update :unsaved-changes
            assoc
            :client-order/delivery-company-id
            {:old-value (:client-order/delivery-company-id client-order)
             :new-value (:id delivery-company)}
            :client-order/customer-contact-id
            {:old-value (:client-order/customer-contact-id client-order)
             :new-value id}
            :client-order/customer-shipping-address-id
            {:old-value (:client-order/customer-shipping-address-id client-order)
             :new-value (:id shipping-address)}
            :client-order/customer-billing-address-id
            {:old-value (:client-order/customer-billing-address-id client-order)
             :new-value (:id billing-address)}))))))

(defmethod grid/action :admin.wholesale/client-order.search-customers
  [app-atom {:keys [search customer-id] :as cfg} _]
  (toaster/open-toast app-atom :processing "Searching for customers" {})
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :search-input search)
    (comms/send :admin.wholesale/client-order.search-customers
      {:customer-id customer-id
       :form/search search
       :form/list-input (:form/list-input cfg)})))

(defmethod comms/receive :admin.wholesale/client-order.search-customers [app-atom e]
  (toaster/close-toast app-atom)
  (let [process-atom (cmn/process-cursor app-atom)
        search-input (cmn/curact process-atom :search-input)]
    (when (= search-input (:form/search e))
      (swap! process-atom assoc (:form/list-input e) (:customers e)))))

(rum/defc customer-details < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-atom (rum/cursor process-atom :client-order)
        customers (cmn/curact process-atom :customers)
        customers-idx (yuc/index-by :client-order-user-id customers)
        customer-client-order-user-id (cmn/curact client-order-atom :client-order/user-id)
        client-order-description (cmn/curact client-order-atom :client-order/description)
        customer (get customers-idx customer-client-order-user-id)
        customer-contacts (cmn/curact process-atom :customer-contacts)
        customer-addresses (cmn/curact process-atom :customer-addresses)
        billing-addresses (filter #(contains? #{"Business" "Billing"} (:address-type %)) customer-addresses)
        customer-form-field-atom (rum/cursor-in process-atom [:form :client-order :client-order/user-id])
        customer-form-field-error (cmn/curact customer-form-field-atom :error)
        customer-form-field-value (cmn/curact customer-form-field-atom :value)
        field-warning (not= (yuc/presence customer-form-field-value) (yuc/presence customer-client-order-user-id))]

    [:<>
     (headings/heading "Customer details:" {:type :h4 :size :tiny :class "u-margin-bottom-24"})
     [:div.form-field
      {:class
       (cond
         customer-form-field-error ["form-field--error"]
         field-warning ["form-field--warning"])}
      (rum/with-key
        (forms/form-field
          "Customer company name:" {}
          (forms/inline-autocomplete-field
            (if customer
              [:span.u-block.u-margin-top-12.faux-input-combo__placeholder
               (:name customer)]
              [:span.u-block.u-margin-top-12.faux-input-combo__placeholder "Search for customers"])
            (rum/cursor process-atom :list-all-customers)
            {:select-style? true
             :empty-list-hint "No customers found"
             :min-count 2
             :item-render-fn
             (fn [item] (str (:customer/display-name item)))

             :change-fn
             #(grid/dispatch-action app-atom :admin.wholesale/client-order.search-customers
                {:search %
                 :customer-id (:id customer)
                 :form/list-input :list-all-customers})

             :select-fn
             (fn [a _]
               (grid/dispatch-action app-atom
                 :admin.wholesale/client-order.change-customer-details
                 {:customer-id (:customer/id a)
                  :client-order-user-id (:customer/client-order-user-id a)}))}))
        "customer")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select process-atom :client-order :client-order/customer-contact-id "Contact name:"
          (map
            (fn [v]
              {:text (:name v) :value (:id v)})
            customer-contacts)
          {:first-option {:text "- Select -" :value 0}
           :type :number
           :change-fn
           (fn [_ id]
             (let [{:keys [email tel]}
                   (->>
                     customer-contacts
                     (filter #(= (str id) (str (:id %))))
                     (first))]

               (swap! client-order-atom assoc
                 :client-order/email email
                 :client-order/tel tel)))})
        "customer")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Contact number:" process-atom :client-order :client-order/tel {})
        "customer-tel")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Contact email:" process-atom :client-order :client-order/email {})
        "customer-email")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-input process-atom :client-order :client-order/description
          "Reference number:" ""
          {:disabled (str/starts-with? client-order-description "YCS")})
        "order-reference")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select process-atom :client-order :client-order/customer-billing-address-id
          "Billing address line 1:"
          (map
            (fn [v]
              {:text (:display-line-1 v) :value (:id v)})
            billing-addresses)
          {:first-option {:text "- Select -" :value 0}
           :type :number
           :change-fn
           (fn [_ id]
             (let [{:keys [display-line-2]}
                   (->>
                     billing-addresses
                     (filter #(= (str id) (str (:id %))))
                     (first))]

               (swap! client-order-atom assoc
                 :client-order/billing-display-line-2 display-line-2)))})
        "billing-address-line-1")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Billing address line 2:" process-atom :client-order :client-order/billing-display-line-2 {})
        "billing-address-line-2")]]))

(rum/defc accounting-details < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        page (cmn/process-name app-atom)]

    [:<>
     (headings/heading "Accounting details:" {:type :h4 :size :tiny :class "u-margin-bottom-24"})
     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Payment terms:" process-atom :client-order :client-order/payment-term-description {})
        "payment-terms")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Tax rule:" process-atom :client-order :client-order/tax-rule-description {})
        "tax-rule")]


     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Invoice number:" process-atom :invoice :invoice/invoice-number {})
        "invoice-display")]

     [:div.form-field
      (rum/with-key
        (datepicker/datepicker app-atom "Date invoiced:" "dd/mm/yyyy"
          [page :client-order :client-order/date-invoiced]
          {:header "Date Invoiced"
           :datatype :date/dmy
           :disabled true})
        "date-invoiced")]]))

(rum/defc shipping-details < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        page (cmn/process-name app-atom)
        client-order-atom (rum/cursor process-atom :client-order)
        client-order (rum/react client-order-atom)
        warehouses (cmn/curact process-atom :warehouses)
        customer-addresses (cmn/curact process-atom :customer-addresses)
        shipping-addresses (filter #(contains? #{"Business" "Shipping"} (:address-type %)) customer-addresses)
        shipping-addresses-idx (yuc/index-by :id shipping-addresses)
        selected-shipping-address (get shipping-addresses-idx (:client-order/customer-shipping-address-id client-order))
        delivery-companies (cmn/curact process-atom :delivery-companies)]

    [:<>
     (headings/heading "Shipping details:" {:type :h4 :size :tiny :class "u-margin-bottom-24"})

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select process-atom :client-order :client-order/warehouse-id "Fulfillment warehouse:"
          (map
            (fn [v]
              {:text (:name v) :value (:id v)})
            warehouses)
          {:first-option {:text "- Select -" :value 0}
           :type :number})
        "warehouse")]

     [:div.form-field
      (rum/with-key
        (datepicker/datepicker app-atom "Date placed:" "dd/mm/yyyy"
          [page :client-order :client-order/date-placed]
          {:header "Date"
           :datatype :date/dmy
           :disabled true})
        "date-placed")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-autocomplete-select process-atom
          :shipping-addresses
          :client-order :client-order/customer-shipping-address-id
          "Shipping address line 1:" selected-shipping-address shipping-addresses
          {:select-style? true
           :empty-list-hint "No Shipping Address found."
           :min-count 2
           :render-fn (fn [item] (:display-line-1 item))
           :select-fn
           (fn [selected-option]
             (let [{:keys [display-line-2]}
                   (->>
                     shipping-addresses
                     (filter #(= (str (:id selected-option)) (str (:id %))))
                     (first))]
               (swap! client-order-atom assoc
                 :client-order/customer-shipping-address-id (:id selected-option)
                 :client-order/shipping-display-line-2 display-line-2)))})
        "shipping-address-line-1")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-disabled "Shipping address line 2:" process-atom :client-order :client-order/shipping-display-line-2 {})
        "shipping-address-line-2")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select process-atom :client-order :client-order/delivery-company-id
          "Carrier / Service:"
          (map
            (fn [v]
              {:text (:name v) :value (:id v)})
            delivery-companies)
          {:first-option {:text "- Select -" :value 0}
           :type :number})
        "carrier-service")]

     (when (yuc/presence (:client-order/date-to-ship client-order))
       [:div.form-field
        (rum/with-key
          (w.cmn/form-date app-atom page :client-order :client-order/date-to-ship "Date to Ship:"
            {:header "Date"
             :datatype :date/dmy
             :disabled false})
          "date-to-ship")])]))

(rum/defc client-order-overview < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        client-order-atom (rum/cursor process-atom :client-order)
        client-order (rum/react client-order-atom)
        invoice (rum/cursor process-atom :invoice)
        override-client-order (cmn/curact action-atom :override-client-order)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        unsaved-changes (cmn/curact process-atom :unsaved-changes)
        wholesale-statuses (cmn/curact process-atom :wholesale-statuses)
        tags (map :name (cmn/curact process-atom :tags))
        backorder? (some #{"Backorder"} tags)
        order-status (:order-status wholesale-statuses)
        fulfilment-status (:fulfilment-status wholesale-statuses)
        finance-status (:finance-status wholesale-statuses)

        disabled?
        (and
          (or
            (contains? #{"Cancelled" "Ready to Ship" "Sent to Courier" "Delivered"} (:client-order/status client-order))
            (contains? #{"Authorised" "Paid"} (:invoice/status invoice))
            (= dear-sync :pull))
          (not override-client-order))]

    [:<>
     (headings/heading "Client order:" {:type :h1 :size :default :flush true})
     [:div.u-margin-bottom-30
      {:class
       (yuc/bem :flex-grid-group [:valign-middle :align-left :flush-force])}
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (headings/heading
          (str
            "#SO-" (:client-order/ref-id client-order)
            " for "
            (:customer/name  client-order))
          {:type :h2
           :size :large
           :flush true})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:align-right :fluid])}
       [:div.flex-grid-content
        [:div
         {:class
          (yuc/bem :flex-grid-group [:valign-middle :align-left :flush-force])}
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           (buttons/button-web "Back"
             {:style :secondary
              :icon :arrow-left
              :on-click
              #(grid/dispatch-action app-atom :admin.wholesale/check.unsaved-changes
                 {:unsaved-changes unsaved-changes
                  :confirm-fn
                  (fn [_]
                    (urlstate/back))})})]]]]]]

     [:div.u-margin-bottom-30
       {:class (yuc/bem :card [:no-hover] :text-card [:small])}
       [:div
        {:class (yuc/bem :flex-grid-group [:align-left :valign-middle :flush])}
        [:div
         {:class (yuc/bem :flex-grid-block [:ml-grow-yes :ml-fluid])}
         [:div.flex-grid-content
          [:div
           {:class
            (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
           [:div
            {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
            [:div.flex-grid-content
             [:div
              {:class
               (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content [:b "Order status:"]]]
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content
                [:span
                 {:class (yuc/bem :text-pill [:dark :medium])}
                 (if backorder? "Backorder" order-status)]]]]]]
           [:div
            {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
            [:div.flex-grid-content
             [:div
              {:class
               (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content [:b "Fulfillment status:"]]]
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content
                [:span
                 {:class (yuc/bem :text-pill [:dark :medium])}
                 fulfilment-status]]]]]]
           [:div
            {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
            [:div.flex-grid-content
             [:div
              {:class
               (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content [:b "Finance status:"]]]
              [:div
               {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
               [:div.flex-grid-content
                [:span
                 {:class (yuc/bem :text-pill [:dark :medium])}
                 finance-status]]]]]]]]]
        [:div
         {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
         [:div.flex-grid-content
          [:div.u-margin-bottom-30
           {:class
            (yuc/bem
              :flex-grid-group
              [:valign-middle :align-left :flush-force])}
           [:div
            {:class (yuc/bem :flex-grid-block [:fluid])}
            (buttons/button-web (if override-client-order "Disable override" "Override client order")
              (if override-client-order
                (merge
                  (urlstate/href-on-click
                    #(grid/dispatch-action app-atom :admin.wholesale/client-order.order.override {}))
                  {:style :negative
                   :size :small
                   :icon :wrench})
                (merge
                  (urlstate/href-on-click
                    #(grid/single-input-modal app-atom
                       {:title "Override client order"
                        :text "This action will allow you to edit items on the Order Tab"
                        :cancel-text "Cancel"
                        :save-key :admin.wholesale/client-order.order.override
                        :input-key :override-reason
                        :field-text "Reason"
                        :auto-focus true}))
                  {:style :negative
                   :size :small
                   :icon :wrench})))]
           [:div
            {:class (yuc/bem :flex-grid-block [:fluid])}
            [:div.flex-grid-content
             (buttons/button-web "View in Weber"
               {:href (str "https://weber.yuppiechef.com/admin/reports/history/" (:client-order/uuid client-order))
                :style :secondary
                :size :small
                :target "_blank"})]]
           [:div
            {:class (yuc/bem :flex-grid-block [:fluid])}
            [:div.flex-grid-content
             (buttons/button-web "Cancel client order"
               (merge
                 (urlstate/href-on-click
                   #(grid/dispatch-action app-atom
                      :admin.wholesale/client-order.cancel
                      {:uuid (:client-order/uuid client-order)}))
                 {:style :error
                  :size :small
                  :icon :delete
                  :disabled disabled?}))]]]]]]]

     [:div.u-margin-bottom-30
      {:class (yuc/bem :accordion [:card])}
      [:h3.accordion__heading
       [:a
        {:on-click #(swap! client-order-atom update :client-order/open? not)
        :class (yuc/bem :accordion__heading-link [(when (:client-order/open? client-order) :is-active)])}
        [:span.accordion__heading-text "Client order details"]
        [:span.accordion__heading-icon-wrapper
         [:i.accordion__heading-icon.js-accordion-icon
          {:class (yuc/bem :icon [:block :default :is-dark (if (:client-order/open? client-order) :minus :plus)])}]]]]
      (when (:client-order/open? client-order)
      [:div
       {:class (yuc/bem :accordion__content-wrapper [(when (:client-order/open? client-order) :is-open)])}
       [:div.accordion__content
        [:div.u-margin-bottom-30
         [:div
          {:class (yuc/bem :flex-grid-group [:align-left])}
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (customer-details app-atom)]]
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (accounting-details app-atom)]]
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (shipping-details app-atom)]]
          [:div
           {:class (yuc/bem :flex-grid-block [:full])}
           [:div.flex-grid-content
            (headings/heading "Customer comments:" {:type :h4 :size :tiny :class "u-margin-bottom-24"})
            (w.cmn/form-textarea process-atom :client-order :client-order/message
              "Comments:" {:disabled disabled?})]]
          [:div
           {:class (yuc/bem :flex-grid-block [:full])}
           [:div
            {:class (yuc/bem :flex-grid-group [:align-left :flush-force])}
            [:div
             {:class (yuc/bem :flex-grid-block [:m-fluid])}
             [:div.flex-grid-content
              (buttons/button-web "Save changes"
                (merge
                  (urlstate/href-on-click
                    #(grid/dispatch-action app-atom
                       :admin.wholesale/client-order.save {}))
                  {:style :primary
                   :icon :save
                   :disabled (or disabled? (empty? unsaved-changes))
                   :class "u-min-width-240"}))]]
            [:div
             {:class (yuc/bem :flex-grid-block [:m-fluid])}
             [:div.flex-grid-content
              (buttons/button-web "Discard changes"
                (merge
                  (urlstate/href-on-click
                    #(grid/dispatch-action app-atom
                       :admin.wholesale/client-order.discard {}))
                  {:style :negative
                   :icon :delete
                   :disabled (or disabled? (empty? unsaved-changes))
                   :class "u-min-width-240"}))]]]]]]]])]

     (tabs/tabbed-content
       ""
       ""
       [(tabs/tab
          (str "Order items")
          [(order-tab/display-order-items app-atom)]
          {:id "order"
           :icon :package})
        (tabs/tab-action
          (str "Packing & Shipping")
          [(shipping-tab/display-packaging-shipping app-atom)]
          {:id "packing-and-shipping"
           :icon :truck-out
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/client-order.shipping.item-list {})})
        (tabs/tab-action
          (str "Invoice")
          [(invoice-tab/display-invoice app-atom)]
          {:id "invoice"
           :icon :cash
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/client-order.invoice.item-list {})})
        (tabs/tab-action
          (str "Credit Note")
          [(credit-note-tab/display-credit-note app-atom)]
          {:id "credit-note"
           :icon :document
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/client-order.initiate.credit-note-lines {})})
        #_(tabs/tab-action
          (str "Manual Journals")
          [(manualjournals-tab/display-manual-journals app-atom)]
          {:id "manual-journals"
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/client-order.manual-journals.item-list {})})
        (tabs/tab-action
          "Attachments"
          [(attachments/attachments-tab app-atom)]
          {:id "attachments"
           :icon :attachment
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/client-order.attachment.item-list {})})
        (tabs/tab-action
          "Change Logs"
          [(changelog-tab/changelogs-tab app-atom)]
          {:id "change-logs"
           :icon :document
           :on-click-fn
           #(grid/dispatch-action app-atom :wholesale.clientorders.overview/client-order.changelogs-init {})})])
     (toaster/loading-overlay app-atom :admin.wholesale/client-order.overview)
     (when (and (not disabled?) (not (empty? unsaved-changes)))
       (w.cmn/floating-save-button #(grid/dispatch-action app-atom :admin.wholesale/client-order.save {})))]))

(defmethod flow/render-screen :admin.wholesale/client_order_overview [app-atom _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-atom (rum/cursor process-atom :client-order)
        client-order (rum/react client-order-atom)
        action-atom (cmn/action-cursor app-atom)
        override-client-order (cmn/curact action-atom :override-client-order)]
    [:div
     (when override-client-order
       {:style
        {:border-style "solid"
         :border-width "thick"
         :border-color "#ffa510"
         :border-spacing "100px"
         :border-inline-end "none"}})
     (w.cmn/wholesale-wrapper app-atom
       {:main-page "Client Orders"
        :main-action "client_orders"
        :current-page-title (str "Overview of #SO-" (:client-order/ref-id client-order))
        :confirm-leave (confirm-leave? app-atom)
        :confirm-leave-modal-key :admin.wholesale/check.unsaved-changes}
       (client-order-overview app-atom))]))

(defmethod t/transition-after-open :admin.wholesale/client_order_overview [app-atom _ _]
  (toaster/open-overlay app-atom :admin.wholesale/client-order.overview)
  (dcommon/kill-search-bar)
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        current-client-order (cmn/curact process-atom :client-order)
        screen-params (cmn/screen-params app-atom)
        reset-page? (not= (str (:uuid screen-params)) (:client-order/uuid current-client-order))]

    ;;TODO: Merge the assoc && dissoc into one... + maybe try the action-atom one too!
    (when reset-page?
      (swap! process-atom dissoc
        :client-order/credit-note-allocations
        :client-order
        :wholesale-statuses
        :tax-rules
        :delivery-companies
        :customers
        :credit-note
        :payment-terms
        :warehouses
        :invoice
        :customer-addresses
        :client-order/order.item-list
        :client-order/shipping.item-list
        :reset-page?
        :company/id
        :customer-contacts)
      (swap! action-atom dissoc
        :client-order/invoice.item-list
        :client-order/payment.item-list
        :credit-note/credit-note-lines
        :client-order/credit-note.allocations
        :attachments.table
        :change-logs.table))

    (editor/initiate app-atom (o.cfg/order-items-editor-config app-atom))
    (editor/initiate app-atom o.cfg/order-additional-charges-editor-config)
    (swap! process-atom assoc
      :reset-page? reset-page?
      :unsaved-changes {}
      :client-order {:client-order/uuid (str (:uuid screen-params))})
    (comms/send :admin.wholesale/client-order.overview {:uuid (:uuid (cmn/screen-params app-atom))})
    (grid/dispatch-action app-atom :admin.wholesale/client-order.order.item-list {})))

(defmethod t/confirm-leave? :admin.wholesale/client_order_overview [app-atom _] (confirm-leave? app-atom))

(defmethod comms/receive :admin.wholesale/client-order.overview
  [app-atom
   {:keys
    [client-order warehouses customers invoice customer-contacts customer-addresses wholesale-statuses
     payment-terms tax-rules delivery-companies credit-note credit-notes credit-note-allocations tags alert] :as overview-data}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
  (when alert
    (grid/open-modal app-atom :grid/message
      {:title "Warning"
       :text
       (feedback/feedback :warning
         [:p alert])}))
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        process-name (cmn/process-name app-atom)
        reset-page? (cmn/curact process-atom :reset-page?)
        shipping-address-id (:client-order/customer-shipping-address-id client-order)
        billing-address-id (:client-order/customer-billing-address-id client-order)
        customer-addresses-idx (yuc/index-by :id customer-addresses)

        shipping-address (get customer-addresses-idx shipping-address-id)
        billing-address (get customer-addresses-idx billing-address-id)

        updated-client-order
        (assoc client-order
          :client-order/shipping-display-line-2 (:display-line-2 shipping-address)
          :client-order/billing-display-line-2 (:display-line-2 billing-address))]

    (swap! app-atom update process-name
      (fn [process]
        (->
          process
          (assoc
            :client-order updated-client-order
            :dear-sync/method (:dear-sync/method overview-data)
            :wholesale-statuses wholesale-statuses
            :tags tags
            :reset-page? false
            :invoice invoice
            :credit-notes credit-notes
            :credit-note credit-note
            :customers customers
            :customer-contacts customer-contacts
            :customer-addresses customer-addresses
            :payment-terms payment-terms
            :tax-rules tax-rules
            :delivery-companies delivery-companies
            :warehouses warehouses
            :client-order/credit-note-allocations credit-note-allocations)
          (update-in [:form]
            (fn [form-entity]
              (let [field-keys (keys updated-client-order)]
                (reduce
                  (fn [acc field-key]
                    (let [new-value (get updated-client-order field-key)]
                      (update-in acc [:client-order field-key] assoc :value new-value)))
                  form-entity field-keys)))))))

    (swap! action-atom assoc :override-client-order (:client-order/override overview-data))

    (when reset-page?
      (datatables/reset-data app-atom
        (o.cfg/order-items-table-config app-atom)
        o.cfg/order-items-table-fns)
      (datatables/reset-data app-atom
        (o.cfg/additional-charges-table-config app-atom)
        o.cfg/additional-charges-table-fns))

    (when (yuc/presence (:client-order/id client-order))
      (datatables/initiate app-atom
        (o.cfg/order-items-table-config app-atom)
        o.cfg/order-items-table-fns)
      (datatables/initiate app-atom
        (o.cfg/additional-charges-table-config app-atom)
        o.cfg/additional-charges-table-fns))

    (presence/open app-atom {:ent/uuid (yuc/uuid (:client-order/uuid client-order)) :context/type :client-order})))

(defmethod grid/action :admin.wholesale/client-order.order.override [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)
        action-atom (cmn/action-cursor app-atom)
        current-override-value (cmn/curact action-atom :override-client-order)
        permission?
        (or
          (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
          (cmn/has-permission? app-atom "SiteAdmin:Wholesale:ClientOrder:Override"))]

    (cond
      permission?
      (do
        (toaster/open-overlay app-atom :admin.wholesale/client-order.overview
          {:text (if current-override-value "Disabling override" "Enabling Override")})
        (comms/send :admin.wholesale/client-order.order.override
          {:uuid (:client-order/uuid client-order)
           :override-value current-override-value
           :override-reason (:override-reason config)}))

      :else
      (grid/dispatch-action app-atom :admin.wholesale/wholesale.unauthorised-warning
        {:permission "SiteAdmin:Wholesale:ClientOrder:Override"}))))

(defmethod comms/receive :admin.wholesale/client-order.order.override [app-atom {:keys [success override]}]
  (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)]
    (when success
      (swap! action-atom assoc :override-client-order override)
      (o.cfg/reset-order-table-buttons app-atom))))

(defmethod grid/action :admin.wholesale/client-order.cancel [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order (cmn/curact process-atom :client-order)]

    (grid/open-modal app-atom :grid/confirm
      {:title "Are you sure you want to cancel this order?"
       :cancel-text "Cancel"
       :confirm-fn
       (fn [app-atom]
         (toaster/open-overlay app-atom :admin.wholesale/client-order.overview)
         (comms/send :admin.wholesale/client-orders.cancel-sale-order
           {:action :remove
            :pre-submit-data {:action-key :admin.wholesale/client-order.overview-cancel}
            :data [{:client-order/uuid (:client-order/uuid client-order)}]}))
       :text "This will be irreversible!"})))

(defmethod grid/action :admin.wholesale/client-order.overview-cancel [app-atom {:keys [success rows msg]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        client-order-atom (rum/cursor process-atom :client-order)
        cancelled-client-order (first rows)]
    (toaster/close-overlay app-atom :admin.wholesale/client-order.overview)
    (cond
      success
      (do
        (toaster/open-toast app-atom :success msg {})
        (swap! client-order-atom assoc :client-order/status (:client-order/status cancelled-client-order))
        (urlstate/redirect app-atom "wholesale" "client_orders"))

      :else
      (toaster/open-toast app-atom :error msg {}))))